import { findCapabilityCatalogEntry } from "./capabilityCatalog";

import type { CapabilityEvidence } from "./capabilityResolution";

export interface CapabilityAvailabilityReader {
  getCapabilityState(
    capability: string,
  ): "available" | "degraded" | "missing" | "unknown";
}

export class CyanWorkerSelectionService {
  constructor(private readonly availability: CapabilityAvailabilityReader) {}

  resolve(capabilities: readonly string[]): CapabilityEvidence[] {
    return capabilities.map((capability) => {
      const catalog = findCapabilityCatalogEntry(capability);

      const state = this.availability.getCapabilityState(capability);

      return {
        capability,
        state,
        provider: catalog?.provider,
        worker: catalog?.preferredWorker,
        reason: catalog
          ? undefined
          : "Capability is not yet registered in the canonical catalog.",
      };
    });
  }
}
